import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SINGLE_ROW_SELECT, MULTIPLE_ROW_SELECT } from './constants.js';

/**
 * getRowSelection - returns the type of row selection
 * TODO this function looks like overkill
 * @param { SINGLE_ROW_SELECT | MULTIPLE_ROW_SELECT | undefined} rowSelection
 * @returns { SINGLE_ROW_SELECT | MULTIPLE_ROW_SELECT | null}
 */

var getRowSelection = function getRowSelection(rowSelection) {
  if (rowSelection === SINGLE_ROW_SELECT) {
    return rowSelection;
  }
  if (rowSelection === MULTIPLE_ROW_SELECT) {
    return rowSelection;
  }
  return null;
};

/**
 * getUniqueGroupValuesByField - returns a set of unique data based on a single field, used for creating parent level row grouping values
 * @param {Array<any>} displayData
 * @param {string} field
 * @returns {Array<any>}
 */

var getUniqueGroupValuesByField = function getUniqueGroupValuesByField(displayData, field) {
  var rowGroupValues = displayData.map(function (row) {
    return row[field];
  });
  // Dedupe fields
  return Array.from(new Set(rowGroupValues)).map(function (item) {
    // Map with field attribute so it can be used with our sort utils
    return _defineProperty({}, field, item);
  });
};

/**
 * sliceRowsByItemRange - when pagination is enabled, the rows will display based on a provided range
 * @param {Array<any>} displayData
 * @param {number} start
 * @param {number} end
 * @param {boolean} isClient
 * @returns {Array<any>}
 */
var sliceRowsByItemRange = function sliceRowsByItemRange(displayData, start, end, isClient) {
  return isClient ? displayData.slice(start, end) : displayData;
};

/**
 * getRowGroupDataByExpandedField - filters out row data by selected field
 * @param {Array<any>} rows
 * @param {string} field
 * @param {string} expandedRowGroup
 * @returns {any}
 */
var getRowGroupDataByExpandedField = function getRowGroupDataByExpandedField(rows, field, expandedRowGroup) {
  return expandedRowGroup ? rows.filter(function (row) {
    return row[field] === expandedRowGroup;
  }) : [];
};

export { getRowGroupDataByExpandedField, getRowSelection, getUniqueGroupValuesByField, sliceRowsByItemRange };
